<template>
    <VModalWrapper :name="name" :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }" v-if="itemId">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <!-- КУДА ИМЕННО ВЕРНЁТСЯ — СКАЗАНО ЗАРАНЕЕ. Правило то же, что у возврата
                     из ремонта, и вопрос у них один: куда вещь возвращается в оборот. -->
                <p class="inventory-action-modal__hint">
                    <template v-if="holderName">
                        Отметка снимется, и оборудование вернётся в работу к <strong>{{ holderName }}</strong> — статус
                        станет «В эксплуатации».
                    </template>

                    <template v-else>
                        Отметка снимется, и оборудование вернётся на склад: ответственного у него нет.
                    </template>
                </p>

                <!-- Комментарий необязателен: «оказалось, что исправно» — само по себе
                     достаточное объяснение, а обязательное поле заполняют точкой. -->
                <ValidationProvider class="active-form__field" name="clear-fault-comment" v-slot="{ errors }">
                    <label class="active-form__label" for="clear-fault-comment">Комментарий</label>

                    <VInput
                        id="clear-fault-comment"
                        name="clear-fault-comment"
                        class="active-form__control"
                        placeholder="Например: оказалось, не тот кабель"
                        :disabled="isSaving"
                        v-model="comment"
                    ></VInput>

                    <span class="active-form__error">{{ errors[0] }}</span>
                </ValidationProvider>

                <p class="active-form__error inventory-action-modal__error" v-if="error">{{ error }}</p>

                <div class="active-form__actions">
                    <VButton
                        type="button"
                        class="active-form__action button_green-light"
                        :disabled="isSaving"
                        @click="hide"
                    >
                        Отмена
                    </VButton>

                    <VButton type="submit" class="active-form__action button_green" :disabled="isSaving">
                        {{ isSaving ? 'Сохраняем…' : 'Снять отметку' }}
                    </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
// Components
import VInput from '../../../components/VInput/VInput.vue';
import VButton from '../../../components/VButton/VButton.vue';
import VModalWrapper from '../../../components/VModalWrapper/VModalWrapper.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

// Other
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../../../js/enums/ModalNames';
import ModalMixin from '../../../../js/vue/mixins/ModalMixin';
import { clearInventoryItemFault } from '../../../../js/inventory-api';
import { errorMessage } from '../../../../js/error';

/**
 * Снятие отметки о неисправности (7-F2C).
 *
 * ОДНО ДЕЙСТВИЕ, А НЕ ДВА. Куда вернётся вещь — «в эксплуатацию» или «на склад», —
 * решает держатель, и решает это сервер: две кнопки, отличающиеся только тем, есть ли
 * у предмета ответственный, человеку пришлось бы различать самому, глядя на карточку.
 * Окно лишь называет результат заранее.
 *
 * НЕ «ПОЧИНИЛИ». Для ремонта есть свой путь и своё событие; это про «оказалось, что
 * исправно» — не тот кабель, села батарея, перезагрузили.
 */
@Component({
    components: {
        VInput,
        VButton,
        VModalWrapper,

        ValidationObserver,
        ValidationProvider,
    },
})
class VInventoryItemClearFaultModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.INVENTORY_ITEM_CLEAR_FAULT })
    name;
    @Prop({ type: String, default: 'Снятие отметки о неисправности' })
    defaultTitle;

    itemId = null;
    holderName = '';
    comment = '';
    error = '';
    isSaving = false;

    async submit() {
        if (this.isSaving || !this.itemId) {
            return;
        }

        this.isSaving = true;
        this.error = '';

        try {
            const response = await clearInventoryItemFault(this.itemId, { comment: this.comment });

            this.resolve(response.data);
            this.hide();
        } catch (requestError) {
            this.error = errorMessage(requestError);
        } finally {
            this.isSaving = false;
        }
    }

    beforeOpen(event) {
        const params = event?.params ?? {};

        this.itemId = params.itemId ?? null;
        this.holderName = params.holderName || '';
        this.comment = '';
        this.error = '';
        this.isSaving = false;
    }

    beforeClose() {
        this.itemId = null;
        this.comment = '';
        this.error = '';
    }
}

export default VInventoryItemClearFaultModal;
</script>
